import { media, styled } from '@styles';
// import { css } from 'styled-components';

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 65vh;
`;

export const Content = styled.div`
  padding: 100px 136px;
  ${media.xLargeScreen`
    padding: 80px 120px;
  `}
  ${media.largeScreen`
    padding: 111px 92px;
  `}
  ${media.smallScreen`
    padding: 84px 24px;
  `}
  .color-sample {
    max-width: 688px;
    padding:0;
    ${media.mediumScreen`
      max-width: 100%;
    `}
`;
